import React from 'react'
import { Clock, Truck, CheckCircle, AlertCircle, XCircle, RotateCw, DollarSign, Trash, ShoppingCart } from 'lucide-react'

const OrderStatus = ({ status, className, withIcon = true, useShoppingIcon = false }) => {
   const statusConfig = {
      'pending': {
         label: 'En attente',
         class: 'badge-warning bg-amber-100 text-amber-800',
         icon: <Clock size={16} className="mr-1" />
      },
      'processing': {
         label: 'En cours',
         class: 'badge-info bg-info-100 text-info-content',
         icon: <RotateCw size={16} className="mr-1" />
      },
      'on-hold': {
         label: 'En attente de vérification',
         class: 'badge-secondary bg-secondary-100 text-secondary-content',
         icon: <AlertCircle size={16} className="mr-1" />
      },
      'completed': {
         label: 'Terminé',
         class: 'badge-primary bg-primary text-primary-content',
         icon: <CheckCircle size={16} className="mr-1" />
      },
      'cancelled': {
         label: 'Annulé',
         class: 'badge-error bg-error-100 text-error-content',
         icon: <XCircle size={16} className="mr-1" />
      },
      'refunded': {
         label: 'Remboursé',
         class: 'badge-warning bg-warning-100 text-warning-content',
         icon: <DollarSign size={16} className="mr-1" />
      },
      'failed': {
         label: 'Échoué',
         class: 'badge-error bg-error-100 text-error-content',
         icon: <AlertCircle size={16} className="mr-1" />
      },
      'trash': {
         label: 'Corbeille',
         class: 'badge-neutral bg-neutral-100 text-neutral-content',
         icon: <Trash size={16} className="mr-1" />
      },
      'livre': {
         label: 'Livrée',
         class: 'badge-success bg-success-100 text-success-content',
         icon: <CheckCircle size={16} className="mr-1" />
      },
      'expedie': {
         label: 'Envoyée',
         class: 'badge-warning bg-warning-100 text-warning-content',
         icon: <Truck size={16} className="mr-1" />
      }
   }

   if (!status || !statusConfig[status]) {
      return null
   }

   const { label, class: badgeClass, icon } = statusConfig[status]


   return (
      <div className={`max-w-32 badge badge-md py-2 px-3 rounded-full flex items-center ${badgeClass} ${className || ''}`}>
         {withIcon && useShoppingIcon ? <ShoppingCart size={16} /> : icon}
         <span className="font-medium truncate">{label}</span>
      </div>
   )
}

export default OrderStatus
